import ListEquipmentTableMobile from "./ListEquipmentTableMobile";

export default ListEquipmentTableMobile;
